/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class EmailTypePop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      style: null,
      emailType: this.props.emailType,
      emailTypeList: [
        {type: '', text: '직접입력'},
        {type: 'naver.com', text: 'naver.com'},
        {type: 'nate.com', text: 'nate.com'},
        {type: 'dreamwiz.com', text: 'dreamwiz.com'},
        {type: 'yahoo.com', text: 'yahoo.com'},
        {type: 'gmail.com', text: 'gmail.com'},
        {type: 'hanmail.net', text: 'hanmail.net'},
        {type: 'hotmail.com', text: 'hotmail.com'},
        {type: 'korea.com', text: 'korea.com'},
        {type: 'chol.com', text: 'chol.com'}
      ]
    };
  }

  componentDidMount() {
    this.setState({ style: Common.getCenterPosStyle(this.layer) }); // 센터 정렬
  }

  /**
   * 이메일 선택 이벤트
   */
  _doChangeEmailTypeEvent = (e) => {
    this.setState({ emailType: e.target.dataset.emailtype });
    var layerBgTimer = setTimeout(() => {
      this.layerBg.click();

      clearTimeout(layerBgTimer);
    }, 200);
  }

  render() {
    return (
      <div className="layer-pop" id="email-pop" style={this.state.style} ref={ref => this.layer = ref}>	
	      <div className="bg" data-emailtype={this.state.emailType} data-type="emailType" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <ul className="sel-list-pop">
          {this.state.emailTypeList.map((entity, index) => <li key={index} className={this.state.emailType === entity.type ? 'active' : ''}><a href={null} data-emailtype={entity.type} onClick={this._doChangeEmailTypeEvent.bind(this)}>{entity.text}</a></li>)}
        </ul>
      </div>
    )
  }
}

export default EmailTypePop;